import React from 'react'
import Icon from 'react-icon-base'

const Tracer = props => (
  <Icon viewBox="0 0 20 17" {...props}>
    <path d="M16.7686 13.1H17.2686V12.6V10.4836V9.98359H16.7686H6.29438H5.79438V10.4836V12.6V13.1H6.29438H16.7686ZM4.17986 13.1H4.67986V12.6V10.4836V9.98359H4.17986H2.11452H1.61452V10.4836V12.6V13.1H2.11452H4.17986ZM17.4333 6.42519L17.4542 6.43282L17.4757 6.43856C17.694 6.49683 17.9213 6.67026 18.101 6.94736C18.2792 7.22219 18.3831 7.55917 18.3831 7.875V13.6336C18.3831 14.4899 17.6231 15.25 16.7686 15.25H2.11452C1.26006 15.25 0.5 14.4899 0.5 13.6336V9.45C0.5 8.59369 1.26006 7.83359 2.11452 7.83359H15.2934L15.4643 6.8637L1.18627 1.6714L1.57286 0.639587L17.4333 6.42519Z" transform="translate(0.365234 0.75)" />
  </Icon>
)

export default Tracer